import Parse from "parse";
import debug from "src/modules/debug-logger";
import { getLocale, getLocaleCountryCode } from "src/utils/locale";

const DEFAULT_LOCALE = "en-US";
const DEFAULT_COUNTRY_CODE = "US";

function formatPrice({ gross, locale, currency }) {
  return new Intl.NumberFormat(locale, { style: "currency", currency }).format(
    gross
  );
}

async function getProductInfo(productId) {
  let locale = getLocale() || DEFAULT_LOCALE;
  const countryCode = getLocaleCountryCode() || DEFAULT_COUNTRY_CODE;

  const url = `https://checkout.paddle.com/api/2.0/prices?product_ids=${productId}&customer_country=${countryCode}`;
  const request = await fetch(url);

  if (!request.ok) throw new Error("Did not manage to fetch products prices");
  const data = await request.json();

  debug.purchase("Received Product Price", data);

  const { customer_country: returnedCountryCode, products } = data.response;
  const localeToUse =
    countryCode === returnedCountryCode ? locale : DEFAULT_LOCALE;

  const { currency, subscription } = products[0];
  let { trial_days: trialDuration } = subscription;
  let trialPeriod = "day";
  if (trialDuration % 31 === 0) {
    trialDuration = trialDuration / 31;
    trialPeriod = "month";
  } else if (trialDuration % 7 === 0) {
    trialDuration = trialDuration / 7;
    trialPeriod = "week";
  }

  return {
    gross: subscription.price.gross,
    price: formatPrice({
      locale: localeToUse,
      currency,
      gross: subscription.price.gross
    }),
    trialDuration,
    trialPeriod
  };
}

export default async function getSubscriptionProducts() {
  const { subscriptionProducts } = await Parse.Cloud.run(
    "getAvailableInAppPurchases",
    {
      platform: "web",
      promotions: []
    }
  );
  let [monthly, yearly] = subscriptionProducts;
  let monthlyLink;
  let yearlyLink;

  if (monthly.isEligibleForIntroductoryPrice) {
    monthlyLink = await Parse.Cloud.run("generatePaddleCheckoutLink", {
      productId: monthly.productId
    });
  } else {
    monthlyLink = await Parse.Cloud.run("generatePaddleNoTrialCheckoutLink", {
      productId: monthly.productId
    });
  }

  if (yearly.isEligibleForIntroductoryPrice) {
    yearlyLink = await Parse.Cloud.run("generatePaddleCheckoutLink", {
      productId: yearly.productId
    });
  } else {
    yearlyLink = await Parse.Cloud.run("generatePaddleNoTrialCheckoutLink", {
      productId: yearly.productId
    });
  }

  monthly = {
    ...monthly,
    ...(await getProductInfo(monthly.productId)),
    link: monthlyLink
  };

  yearly = {
    ...yearly,
    ...(await getProductInfo(yearly.productId)),
    link: yearlyLink
  };

  const yearlyPricePerMonth = yearly.gross / 12;
  const yearlyPriceAsMonthlyPricePercentage =
    (yearlyPricePerMonth / monthly.gross) * 100;
  yearly.save = Math.floor(100 - yearlyPriceAsMonthlyPricePercentage);

  return { monthly, yearly };
}
